import type { BaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';

export const getUrl = (baseUrl: BaseUrl) =>
	`${baseUrl}/rest/servicedesk/1/agent/sla/metric/goal/validate?operation=validateGoalJQL`;
